import { supabase } from "@/integrations/supabase/client";
import { cleanPayload } from "@pps/supabase/payload";
import i18n from "@/i18n";

export async function invokeFunction<T = unknown>(
  functionName: string,
  options?: {
    body?: Record<string, unknown>;
    headers?: Record<string, string>;
  }
): Promise<{ data: T | null; error: Error | null }> {
  const currentLanguage = i18n.language || "pt";
  const headers = { "Accept-Language": currentLanguage, ...options?.headers };
  const body = options?.body ? cleanPayload(options.body) : undefined;
  return supabase.functions.invoke<T>(functionName, { ...options, body, headers });
}
